export enum AdGroup {
  MEMBER = 'member',
  ADMIN = 'admin',
  DIGITALIZATION_COWORKERS = 'digitalizationCoworkers',
  DOCU_MANAGER = 'docuManager',
  DOCU_RESPONSIBLE = 'docuResponsible',
  COWORKER = 'coworker',
  INSPECTOR = 'inspector',
  WORKSPACE_MEMBER = 'workspaceMember',
  WORKSPACE_OWNER = 'owner',
  WORKSPACE_REVIEWER = 'reviewer',
  WORKSPACE_ADMINISTRATOR = 'workspaceAdministrator',
}
